import Modal from 'react-modal';
import { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';

import ConfirmModal from 'root/components/Modals/ConfirmModal';
import ToastMessage from 'root/components/Modals/ToastMessage';
import { openModal } from 'redux/common/slices/modals';

import { addDefectPlaceExcel } from 'api/defect';

import closeIcon from 'root/assets/imgs/icon_close.svg';

import styled from '@emotion/styled';
import { theme } from 'shared/root/styles/theme';
import CommonStyledComponents from 'shared/root/styles/CommonStyledComponents';
const { Button } = CommonStyledComponents;

export default function AddDefectModal({
  modalClose,
  modalSubmit,
  buttonText,
  placeIdx,
  defectIdx,
}) {
  const dispatch = useDispatch();
  const isUpdate = defectIdx ? true : false;
  const infoFileRef = useRef();

  const {
    register,
    handleSubmit,
    formState: { isValid, isDirty },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      excel: '',
      place_idx: placeIdx,
    },
  });

  function handleClickSubmit(data) {
    onSubmitAdd(data);
  }

  const onSubmitAdd = data => {
    addDefectPlaceExcel(data)
      .then(response => {
        dispatch(
          openModal({
            Component: ToastMessage,
            props: {
              iconImg: 'complete',
              message: '하자등록 항목이 추가되었습니다.',
            },
          }),
          modalSubmit(),
        );
      })
      .catch(error => {
        console.log(error);
        dispatch(
          openModal({
            Component: ToastMessage,
            props: {
              iconImg: 'fail',
              message: error.message, //'실패했습니다',
            },
          }),
        );
      });
  };

  function handleClickCloseConfirm() {
    if (isUpdate && isDirty) {
      dispatch(
        openModal({
          Component: ConfirmModal,
          props: {
            message:
              '지금 나가시면 변경사항이 저장되지 않습니다. 그만하시겠습니까?',
            handleModalSubmit: () => {
              modalClose();
            },
          },
        }),
      );
    } else {
      modalClose();
    }
  }

  return (
    <Modal isOpen style={customStyles}>
      <StyleConfirmModal>
        <ModalHeader>
          <ModalTitle>엑셀 등록하기</ModalTitle>
          <CloseButton type="button" onClick={handleClickCloseConfirm}>
            <img src={closeIcon} alt="닫기" />
          </CloseButton>
        </ModalHeader>
        <ModalBody>
          <form method="post" onSubmit={handleSubmit(handleClickSubmit)}>
            <ModalFormField>
              <ModalFormFieldContainer>
                <FileInput>
                  <input
                    type="file"
                    id="excel"
                    ref={infoFileRef}
                    {...register('excel', {
                      required: true,
                    })}
                    accept=".xls,.xlsx"
                  />
                  <label htmlFor={'excel'}>파일선택</label>
                </FileInput>
              </ModalFormFieldContainer>
            </ModalFormField>
            <Buttons>
              <Button
                type="button"
                size={'lg'}
                theme={'outline-default'}
                onClick={handleClickCloseConfirm}
              >
                {buttonText && buttonText.cancel ? buttonText.cancel : '취소'}
              </Button>
              <Button
                type="submit"
                size={'lg'}
                theme={'point'}
                status={isValid ? null : 'disabled'}
                onClick={handleSubmit(d => handleClickSubmit(d))}
              >
                {buttonText && buttonText.submit ? buttonText.submit : '확인'}
              </Button>
            </Buttons>
          </form>
        </ModalBody>
      </StyleConfirmModal>
    </Modal>
  );
}

const customStyles = {
  overlay: {
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    zIndex: '10000',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    width: 'calc(100% - 30px)',
    minWidth: '280px',
    maxWidth: '550px',
    padding: '0',
    borderRadius: '4px',
    transform: 'translate(-50%, -50%)',
    border: 'none',
  },
};

const StyleConfirmModal = styled.div`
  padding: 30px;
`;

const Buttons = styled.div`
  display: grid;
  column-gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(auto, 0));
  justify-content: center;
`;

const ModalHeader = styled.div`
  margin-bottom: 35px;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.22;
  color: #222;
`;
const ModalTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.22;
  color: #222;
`;
const CloseButton = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  width: 80px;
  height: 80px;
  cursor: pointer;
`;
const ModalBody = styled.div``;

const ModalFormField = styled.div`
  margin-bottom: 23px;
`;
const ModalFormFieldLabel = styled.div`
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.57;
  color: #323232;
`;
const ModalFormFieldContainer = styled.div``;

const FileInput = styled.div`
  position: relative;
  display: flex;
  input {
    width: 100%;
    height: 36px;
    padding: 0 10px;
    border-radius: 2px;
    border: 1px solid #e2e5ec;
    line-height: 34px;
    font-size: 14px;
    color: #323232;
    margin-right: 8px;
    cursor: pointer;
    &::placeholder {
      font-size: 16px;
      color: ${theme.colors.placeholder};
    }
    &::file-selector-button {
      display: none;
    }
  }
  label {
    width: 100px;
    padding: 0 12px;
    height: 36px;
    font-size: 14px;
    height: 36px;
    line-height: 34px;
    border-radius: 2px;
    border: 1px solid #e3e4eb;
    background-color: #fff;
    color: #323232;
    text-align: center;
    cursor: pointer;
    &:hover {
      background-color: #f3f6fb;
    }
  }
`;
